<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item ml-2" aria-current="page">
              <a routerLink="/purchase-orders">Purchase Orders</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/proof-of-delivery-service">PO Line Items</a>
            </span>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div *ngIf="sessionExpired" class="alert alert-danger session-text text-center" role="alert">
                {{ errorMsg }}
                <span class="relogin" (click)="accountLogout()">Click here to LogIn</span>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="pane-header mb-3">
                    <h4 class="mt-2">
                      Line Items for PO No.
                      {{ poNo }}
                    </h4>
                  </div>
                  <div class="search-pane">
                    <div class="row">
                      <div class="col-md-2">
                        <label class="d-inline-flex align-items-center mb-3">
                          <select id="show-headers" class="form-select form-select-sm mx-1" (change)="onFilter($event)">
                            <option disabled selected hidden>Select</option>
                            <option value="itemDescription">Item Description</option>
                            <option value="poLineNo">Line Item</option>
                          </select>
                        </label>
                      </div>
                      <div class="col-md-4">
                        <div class="input-group flex-nowrap">
                          <ng-container *ngIf="selectedOption">
                            <input
                              type="text"
                              class="form-control highlighted"
                              placeholder="Enter search value"
                              aria-label="search"
                              aria-describedby="addon-wrapping"
                              (keyup)="onSearch($event)"
                            />
                            <span class="input-group-text highlighted" id="addon-wrapping"><i class="ri-search-line"></i></span>
                          </ng-container>
                          <ng-container *ngIf="!selectedOption">
                            <input type="text" class="form-control" placeholder="Search..." aria-label="search" aria-describedby="addon-wrapping" (keyup)="generalSearch($event)" />
                            <span class="input-group-text" id="addon-wrapping"><i class="ri-search-line"></i></span>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="download-pane float-end d-flex align-items-center gap-3">
                          <i
                            class="ri-refresh-line"
                            title="Refresh"
                            (click)="!loading && reloadPoLineItems()"
                            [style.opacity]="loading ? 0.45 : 1"
                            [style.pointer-events]="loading ? 'none' : 'auto'"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <ng-container *ngIf="loading">
                      <div class="text-center">
                        <app-loader></app-loader>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="!loading">
                      <table
                        aria-describedby="service-po"
                        id="demo-foo-pagination"
                        class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap service-po"
                        data-page-size="5"
                      >
                        <thead>
                          <tr>
                            <th *ngIf="impersonate === 'false' || imp.canSubmitWhileImpersonated()" data-toggle="true">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" [checked]="isAllCheck()" (change)="checkAll($event)" />
                              </div>
                            </th>

                            <th scope="col" [appSort]="po" data-order="desc" data-name="poLineNo" class="text-center">
                              Line Item
                              <span><i class="bi bi-chevron-expand"></i></span>
                            </th>

                            <th scope="col" [appSort]="po" data-order="desc" data-name="itemDescription" class="text-left">
                              Item Description
                              <span><i class="bi bi-chevron-expand"></i></span>
                            </th>

                            <th scope="col" [appSort]="po" data-order="desc" data-name="quantity" class="text-center">
                              Total Quantity
                              <span><i class="bi bi-chevron-expand"></i></span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let line of po; let i = index">
                            <td *ngIf="impersonate === 'false' || imp.canSubmitWhileImpersonated()">
                              <div class="form-check">
                                <input (change)="onCheckboxChange(i)" class="form-check-input" type="checkbox" [(ngModel)]="po[i].checked" />
                              </div>
                            </td>

                            <td class="text-center">
                              {{ formatLineItemNo(line.poLineNo) }}
                            </td>

                            <td class="text-left">
                              {{ line.description }}
                            </td>

                            <td class="text-center">
                              {{ line.quantity }}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="9">
                              <button *ngIf="impersonate === 'false' || imp.canSubmitWhileImpersonated()" [disabled]="!isSelected" class="btn btn-invoice float-end" (click)="sendPo()">Submit Invoice for Selected Item</button>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </ng-container>

                    <div class="table-footer py-3">
                      <div class="row">
                        <div class="col-sm-5">
                          <label class="d-inline-flex align-items-center mb-3">
                            Show
                            <select id="demo-show-entries" class="form-select form-select-sm mx-1" [(ngModel)]="pageSize">
                              <option [ngValue]="10">10</option>
                              <option [ngValue]="25">25</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            entries
                          </label>
                        </div>
                        <div class="col-sm-7">
                          <div class="text-end">
                            <!-- Showing 1-5 of 15 entries -->
                            <ngb-pagination
                              class="justify-content: flex-end !important;"
                              [collectionSize]="collectionSize"
                              [(page)]="page"
                              [pageSize]="pageSize"
                              [maxSize]="4"
                              [rotate]="true"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                              (pageChange)="refreshPo()"
                            >
                            </ngb-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
